import '../../../stylesheets/dashboards/dashboards.css'
import '../../../stylesheets/dashboards/leaderboard.css'
import { useState, useEffect, useRef }                         from 'react'
import { assembleBarLayoutDTO, resolveStackedClassForColor,
         resolveChangeSignage                              }   from '../../../services/leaderboard/main/main.js';
import { formatNumber, formatNumberTwoDecimal,
         formatPercent, formatDollar }                         from '../../../utilities/formatNumber.js';

const SummaryStatsBarLayout = (props) => {

    const {indsPrices, priceDataActiveFields, period, type} = props

    // ** Local Variables **
    const barLayoutDTO = assembleBarLayoutDTO(indsPrices, priceDataActiveFields)

    return (
        <div className="summary-stats-bar-container">
            {indsPrices.map((ipd) => (
                <div key={ipd.id} className="summary-stats-bar-row">
                    <div className="summary-stats-bar-name">{ipd.name}</div>
                    <div className={`summary-stats-bar-track ${barLayoutDTO.barGutter}`}>
                        <div
                            className={`summary-stats-bar-fill ${resolveStackedClassForColor(ipd[priceDataActiveFields.heat], "indices-bar")}`}
                            style={barLayoutDTO.placements[ipd.id]}
                        >
                            <span className={`summary-stats-bar-value ${resolveStackedClassForColor(ipd[priceDataActiveFields.heat], "indices-bar-value")}`}>
                                {/* symbol for change value displayed based on heat (+/-) and type ($/%) */}
                                {resolveChangeSignage(ipd[priceDataActiveFields.change], ipd[priceDataActiveFields.heat], type)}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}


export default SummaryStatsBarLayout;
